import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
//import util from 'util';
import { useParams } from 'react-router';
import "react-datepicker/dist/react-datepicker.css"
import moment from 'moment';
import constClass from '../../Constants/Constants';
import Loading from '../Loading/Loading';
import Select from 'react-select';
import UseConfirmModal from '../Common/UseConfirmModal';
import UseAlertModal from '../Common/UseAlertModal';
import { v4 as uuidv4 } from 'uuid';

const style = {
  result: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    fontSize: "2.5rem",
  },
};

const initialAppState = {
  site_id: null,
  customer_id: null,

  membership_id: null,  //会員ID
  customer_name: '',    //お客様名
  available_point: 0,   //利用可能ポイント
  customer_rank: null,    //会員ランク

  inputValue: 0,      //対象金額
  pointUseFlag: null,       //ポイント利用(つかう:true,ためる:false)
  use_point: 0,   //クーポン利用のポイント

  couponUseFlag: null,
  paymentValue: 0,    //支払金額
  addPoint: 0,        //加算ポイント
  pointBalance: 0,    //ポイント残高

  paymentMethod: constClass.PAYMENT_METHOD.CASH,
  campaignMagnification: null,   //キャンペーン倍率
  campaignName: "",
  addBonusPoint: 0,

  pointCampaignList: null, //現在開催中のキャンペーン一覧

  pointRegist: false,//ポイント付与確定

  mall_id: null,
  shop: null,
  shop_id: null,
  cashier_no: null,
  user_id: null,
  point_rate: null,
  point_base_amount: null,
  point_datetime: null,

  isNow: false,//ポイント後付け
};

var processFlag = false;

const AfterPoint = (props) => {
  const { user, setting } = props;
  const { siteId, mallId } = useParams();
  const [shopMaster, setShopMaster] = useState(null);
  const [lockData, setLockData] = useState(false);
  const [inputFlg, setInputFlg] = useState(false);
  const [appState, setAppState] = useState({ ...initialAppState, site_id: siteId, mall_id: mallId });
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [alertModalMessage, setAlertModalMessage] = useState('');
  const [confirmModalMessage, setConfirmModalMessage] = useState('');
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [onConfirm, setOnConfirm] = useState(() => () => { });
  const [pointUuid, setPointUuid] = useState(null);

  const sysdate = moment().format('YYYY-MM-DDTHH:mm');

  const refreshData = useCallback(async () => {
    if (!setting) return;
    //トークンを取得
    const jwt = localStorage.getItem('jwt');
    const shopData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/shop/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    })).data;
    setShopMaster(shopData);

    //施設情報を取得
    const mall = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/mall/${siteId}/${mallId}`, { site_id: siteId }, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;

    setAppState(prevState => ({
      ...prevState,
      max_point: mall ? Number(mall.point_limit) : 'MAX_POINT' in setting.values[siteId] ? Number(setting['MAX_POINT']) : 0,
      point_rate: setting['DEFAULT_POINT_RATE'] || 0,
      point_base_amount: setting['DEFAULT_POINT_BASE_AMOUNT'] || 0,
      user_id: user.userId,
    }));
  }, [siteId, mallId, setting, user]);

  const Result = ({ result }) => (
    <div className="h-100">
      <span className="h-100" style={style.result}>{Number(result).toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })}</span>
    </div>
  );

  const NumBtn = ({ n, className }) => (
    <button className={`${className} numbtnfont`} onClick={() => { handleNumClick(n) }}>{n}</button>
  );

  const OperatorBtn = ({ t, className, disabled }) => (
    <button disabled={disabled ?? false} className={className} onClick={() => { handleOperatorClick(t) }}>{t}</button>
  );

  const handleChange = (e) => {
    const target = e.target;
    const name = target.name;
    const value = target.value;

    if (name === "membership_id") {
      if (/^\d*$/.test(value) && value.length <= 10) {
        setTimeout(() => {
          setAppState({ ...appState, [name]: value });
        }, 10);
      }
    } else  {
      setTimeout(() => {
        setAppState({ ...appState, [name]: value });
      }, 10);
    }
  };

  const setConditionValue = (value, name) => {
    if (value) {
      if (name === "shop") {
        setAppState({ ...appState, [name]: value, shop_id: value.value});
      } else {
        setAppState({ ...appState, [name]: value});
      }
    } else {
      if (name === "shop") {
        setAppState({ ...appState, [name]: null, shop_id: null});
      } else {
        setAppState({ ...appState, [name]: null});
      }
    }
  };

  const handlePaymentMethod = (type) => {
    var state = {
      ...appState,
      paymentMethod: type,
    };
    setAppState(state);
  }

  const handleNumClick = (n) => {
    if (appState.inputValue.toString().length >= 9) {
      console.log("integer over");
      return false;
    }
    var state = {
      ...appState,
      inputValue: appState.inputValue === 0 ? Number(n) : Number(appState.inputValue.toString() + n)
    };
    if (state.inputValue > 0 && (appState.point_rate > 0 || appState.point_base_amount > 0)) {
      var addPoint = Math.floor((appState.point_rate > 0 ? state.inputValue * (appState.point_rate / 100) : state.inputValue / appState.point_base_amount));
      if (appState.max_point > 0 && addPoint > appState.max_point) addPoint = appState.max_point;
      state = {
        ...state,
        addPoint: addPoint
      };
    }
    setAppState(state);
  }

  const handleOperatorClick = (t) => {
    var state = {
      ...appState,
    };
    switch (t) {
      case "⏎":
        beforeConfirm();
        break;
      case "C":
        state.inputValue = 0;
        state.addPoint = 0;
        break;
      default:
    }
    setAppState(state);
  }

  const fetchData = useCallback(async () => {
    if (appState.membership_id) {
      const jwt = localStorage.getItem('jwt');
      try {
        const customer_data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/card/${siteId}`, { card_id: appState.membership_id }, {
          headers: {
            Authorization: `Bearer ${jwt}`,
          }
        })).data;
        if (customer_data && customer_data.data) {
          var customerId = customer_data.data.customer_id
        
          //ランクマスタ情報を取得
          const rank_info = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/ranklist/`, { site_id: siteId }, {
            headers: {
              Authorization: `Bearer ${jwt}`,
            }
          })).data;

          //現在のユーザのランクを取得
          const rank_customer_info = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerrank/backyard/search/then/`, { site_id: siteId, customer_id: customerId, datetime: appState.point_datetime }, {
            headers: {
              Authorization: `Bearer ${jwt}`,
            }
          })).data;
          //ランク情報がない場合、最初のランクに設定
          const user_rank = rank_customer_info ? rank_customer_info.rank_id : rank_info[0].rank_id;

          setAppState(prevState => ({
            ...prevState,
            customer_id: customerId,
            customer_rank: user_rank >= 1 ? rank_info[user_rank - 1] : null,
          }));

          var point_campaign = null;
          if (appState.customer_id && appState.shop_id && appState.point_datetime) {
            //対象のキャンペーン情報を取得
            const resPointCampaign = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/point_campaign/list/`, { site_id: siteId, mall_id: mallId, shop_id: appState.shop_id, datetime: new Date(appState.point_datetime) }, {
              headers: {
                Authorization: `Bearer ${jwt}`,
              }
            })).data;
            
            const beforeDate = new Date(appState.point_datetime);
            const currentDay = beforeDate.getDay(); // 0: 日曜日, 1: 月曜日, ..., 6: 土曜日
            const currentHour = beforeDate.getHours();
            const day = parseInt(String(beforeDate.getDate()).padStart(2, '0'), 10);
            let isDayValid = null;

            // ポイントキャンペーンをフィルタリング
            point_campaign = resPointCampaign.filter(campaign => {
              if (campaign.m_schedule) {
                // 開始時間、終了時間を確認
                const startTime = campaign.m_schedule.start_time;
                const endTime = campaign.m_schedule.end_time;
                const isTimeValid = currentHour >= startTime && currentHour <= endTime;
                console.log(campaign.m_schedule.schedule_type);
                // スケジュール区分：0(曜日)の場合、当日の曜日、時間帯が適切かどうかでフィルタリング
                if (campaign.m_schedule.schedule_type === "0") {
                  const weekdays = campaign.m_schedule.weekdays;
                  const isWeekdayValid = weekdays.includes(currentDay);
                  return isWeekdayValid && isTimeValid;
                // スケジュール区分：1(日付)の場合、当日の日付、時間帯が適切かどうかでフィルタリング
                } else if (campaign.m_schedule.schedule_type === "1") {
                  const startDate = parseInt(campaign.m_schedule.start_date, 10);
                  const endDate = parseInt(campaign.m_schedule.end_date, 10);
                  if (startDate <= endDate) {
                    isDayValid = day >= startDate && day <= endDate;
                    return isDayValid && isTimeValid;
                  } else {
                    isDayValid = day <= endDate || day >= startDate;
                    return isDayValid && isTimeValid;
                  }
                } else {
                  return false;
                }
              // スケジュールを設定していない場合は無条件でフィルタリング対象
              } else {
                return true;
              }
            }).filter(pointCampaign => 
              pointCampaign.point_campaign_ranks.length === 0 || 
              pointCampaign.point_campaign_ranks.some(rank => rank.rank_id === user_rank)
            );

            setAppState(prevState => ({
              ...prevState,
              customer_id: customerId,
              customer_rank: user_rank >= 1 ? rank_info[user_rank - 1] : null,
              pointCampaignList: point_campaign ? point_campaign : null,
            }));
          } else {
            setAppState(prevState => ({
              ...prevState,
              pointCampaignList: null,
            }));
          }
        }
      } catch (error) {
        console.log(error);
        setAppState(prevState => ({
          ...prevState,
          customer_id: null,
          customer_rank: null,
          pointCampaignList: null,
        }));
      }
    } else {
      setAppState(prevState => ({
        ...prevState,
        membership_id: null,
        customer_id: null,
        customer_rank: null,
      }));
    }
  }, [mallId, siteId, appState.membership_id, appState.customer_id, appState.shop_id, appState.point_datetime]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  useEffect(() => {
    fetchData();
  }, [fetchData, appState.shop]);

  const beforeConfirm = async() => {
    const currentDateTime = moment();

    if (appState.membership_id === null) {
      window.alert('会員IDを入力してください。')
    }
    if (appState.membership_id && appState.customer_id === null) {
      window.alert('有効な会員IDを入力してください。');
      return;
    }

    if (appState.shop === null) {
      window.alert('店舗を選択してください。');
      return;
    }

    if (appState.point_datetime === null || appState.point_datetime === "") {
      window.alert('ポイント発生日時を選択してください。');
      return;
    }
    if (moment(appState.point_datetime).isAfter(currentDateTime)) {
      window.alert('現在の日時以降は選択できません。');
      return;
    }
    setInputFlg(true);
  }

  useEffect(() => {    
    setPointUuid(uuidv4());
    // setTicketUuid(uuidv4());
  }, [setPointUuid]);

  const handleSubmitClick = async () => {
    setConfirmModalMessage('ポイント付与を確定してよろしいですか？');
    setIsConfirmModalOpen(true);
    setOnConfirm(() => async () => {
      setLockData(true);
      closeConfirmModal();
      await setPointRegist(appState);
      setLockData(false);
    });
  }

  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };

  const handleCloseClick = () => {
    setInputFlg(false);
  }

  const closeAlertModal = () => {
    setIsAlertModalOpen(false);
  };

  const setPointRegist = useCallback(async (registAppState) => {
    if (processFlag) {
      return;
    };
    processFlag = true;
    const params = {
      ...registAppState,
      point_uuid: pointUuid,
    };
    try {
      const jwt = localStorage.getItem('jwt');
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/points/${siteId}`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
      if (res && res.data.error) {
        setAlertModalMessage(res.data.message)
        setIsAlertModalOpen(true);
      }
      else {
        if (res && res.data && Array.isArray(res.data.data)) {
          var data = res.data.data;
          const totalPoint = data.reduce((sum, item) => sum + (item.point || 0), 0);
          const campaignList = data.flatMap(item => item.campaignlist || []);
          setAppState(prevState => ({
            ...prevState,
            pointRegist: true,
            addPoint: totalPoint,
            pointCampaignList: campaignList,
          }));
        } else {
          setAppState(prevState => ({
            ...initialAppState,
            site_id: siteId,
            mall_id: mallId,
            user_id: user.userId,
          }));
          setInputFlg(false);
        }
      }
    } catch (err) {
      if (!err.responce) {
        setAlertModalMessage("エラーが発生しました。");
        setIsAlertModalOpen(true);
      } else if (err.response.data !== null) {
        setAlertModalMessage(err.response.data.message)
        setIsAlertModalOpen(true);
      } else {
        setAlertModalMessage(err.response)
        setIsAlertModalOpen(true);
      }
    } finally {
      processFlag = false;
    }

  }, [siteId, mallId, user, pointUuid]);

  const setRegistClose = useCallback(async () => {
    setAppState(prevState => ({ 
      ...initialAppState, 
      site_id: siteId, 
      mall_id: mallId,
      point_rate: setting['DEFAULT_POINT_RATE'] || 0,
      point_base_amount: setting['DEFAULT_POINT_BASE_AMOUNT'] || 0,
      user_id: user.userId,
    }));
    setPointUuid(uuidv4());
    setInputFlg(false);
  }, [user, setting, siteId, mallId]);

  const renderInput = () => {
    return (
      <div>
        {lockData && <Loading />}
        <React.Fragment>
          <div className="row">
            <div className="half full my-3 text-left bg-white mx-4">
              <div className="row">
                <div className="col my-3 text-left bg-white">
                  <div className="card-header p-3 border" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span><b>会員ID:</b></span>
                    <span className="col-5 pl-2" style={{ textAlign: 'right' }}>
                      <input
                        type="text"
                        name="membership_id"
                        value={appState.membership_id || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </span>
                  </div>
                  <div className="card-header p-3 border" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span><b>会員ランク:</b></span>
                    <span className="col-5 pl-2" style={{ textAlign: 'right' }}><b>
                      {appState.customer_rank ? appState.customer_rank.rank_name : appState.membership_id ? "会員が見つかりませんでした" : ""}
                    </b></span>
                  </div>
                  <div className="card-header p-3 border" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span><b>店舗:</b></span>
                    <span className="col-5 pl-2 text-center">
                      <Select
                        styles={{ container: (base) => ({ ...base, zIndex: 600 }) }}
                        options={shopMaster ? shopMaster.map(s => ({ value: s.shop_id, label: `${s.shop_name}` })) : []}
                        isClearable={true}
                        closeMenuOnSelect={true}
                        value={appState.shop ? appState.shop : {}}
                        isDisabled={(shopMaster && shopMaster.length === 1) ? true : false}
                        onChange={(value) => setConditionValue(value, "shop")}
                      />
                    </span>
                  </div>
                  <div className="card-header p-3 border" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span><b>ポイント発生日時:</b></span>
                    <span className="col-5 pl-2" style={{ textAlign: 'right' }}>
                      <input
                        type="datetime-local"
                        name="point_datetime"
                        value={appState.point_datetime || ""}
                        onChange={handleChange}
                        className="form-control"
                        max={sysdate}
                      />
                    </span>
                  </div>
                  {(appState.point_rate > 0 || appState.point_base_amount > 0) && <div className="card-header p-3 border" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span><b>ポイント還元{appState.point_rate > 0 ? "率" : "基準額（税込み）"}:</b></span>
                    <span className="col-5 pl-2" style={{ textAlign: 'right' }}><b>
                      {appState.point_rate ? Number(appState.point_rate) : appState.point_base_amount ? Number(appState.point_base_amount) : null}</b> {appState.point_rate > 0 ? "％" : "円に1ポイント"}
                    </span>
                  </div>}
                </div>
              </div>
              <div className="row">
                <div className="col my-3 text-left bg-white">
                  <div className="card-header p-3 border" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span><b>付与予定ポイント:</b></span>
                    <span className="col-5 pl-2" style={{ textAlign: 'right' }}><b>{appState.addPoint.toLocaleString()}</b> ポイント</span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col my-3 text-left bg-white">
                  <div className="card-header p-3 border">
                    <span><b>開催中の対象キャンペーン:</b></span>
                    {appState.pointCampaignList && (
                      <div className="row">
                        {appState.pointCampaignList
                          .filter(x => 
                            (!Object.values(constClass.PAYMENT_METHOD).includes(x.payment_method.toString()) || 
                            !appState.paymentMethod || 
                            x.payment_method.toString() === appState.paymentMethod.toString())
                          )
                          .map((item, idx) => (
                            <div className="col-12 pl-5 text-left" key={idx}>
                              {item.point_campaign_name}
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="half full my-5 text-left bg-white mt-md-5 mt-4 mx-4">
              <table className="table h-100">
                <tbody>
                  <tr>
                    <td className="p-0" height="60" colSpan="4"><Result result={appState.inputValue} /></td>
                  </tr>
                  <tr>
                    <td className="text-center" colSpan="4">
                      <div className='row'>
                        {appState.mall_id === '1' && Object.keys(constClass.PAYMENT_METHOD).map((p, idx) =>
                          <div key={idx} className={`col-3 p-1`}>
                            <button
                              className={`btn ${appState.paymentMethod === constClass.PAYMENT_METHOD[p] ? "btn-active" : "btn-enable"} w-100 py-3`}
                              onClick={() => { handlePaymentMethod(constClass.PAYMENT_METHOD[p]) }}>
                              {constClass.PAYMENT_METHOD_NAME[p]}
                            </button>
                          </div>
                        )}
                        {appState.mall_id !== '1' && Object.keys(constClass.PAYMENT_METHOD).map((p, idx) =>
                          constClass.PAYMENT_METHOD_NAME[p] !== '現金・商品券' &&
                          <div key={idx} className={`col-3 p-1`}>
                            <button
                              className={`btn ${appState.paymentMethod === constClass.PAYMENT_METHOD[p] ? "btn-active" : "btn-enable"} w-100 py-3`}
                              onClick={() => { handlePaymentMethod(constClass.PAYMENT_METHOD[p]) }}>
                              {constClass.PAYMENT_METHOD_NAME[p]}
                            </button>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr className='no-border'>
                    <td className="text-center no-border" colSpan="4">
                      <div className='row font-weight-bold'>
                        {appState.mall_id === '1' && "値引き前の税込み決済金額を入力"}
                        {appState.mall_id !== '1' && "値引き後の税込み決済金額を入力"}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"7"} /></td>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"8"} /></td>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"9"} /></td>
                    <td className="p-0" height="60" width="25%" rowSpan="2"><OperatorBtn className={"w-100 h-100"} t={"C"} /></td>
                  </tr>
                  <tr>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"4"} /></td>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"5"} /></td>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"6"} /></td>
                  </tr>
                  <tr>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"1"} /></td>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"2"} /></td>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"3"} /></td>
                    <td className="p-0" height="60" width="25%" rowSpan="2"><OperatorBtn className={"w-100 h-100"} t={"⏎"} disabled={appState.membership_id === null || appState.inputValue === 0} /></td>
                  </tr>
                  <tr>
                    <td className="p-0" height="60" colSpan="2"><NumBtn className={"w-100 h-100"} n={"0"} /></td>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"00"} /></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </React.Fragment>
      </div>
    );
  }

  const renderConfirm = () => {
    return (
      <div>
        {lockData && <Loading />}
        <UseConfirmModal isOpen={isConfirmModalOpen} message={confirmModalMessage} onConfirm={onConfirm} onClose={closeConfirmModal} disabled={lockData}/>
        {appState.pointRegist &&
          <div className='text-center font-weight-bold pt-3 text-alert'>ポイント付与が完了しました</div>
        }
        <div className="row">
          <div className="col my-3 text-left bg-white">
            <div className="card-header p-2 border">
              <span><b>会員ID:</b></span>
              <span className="float-right pl-2">{appState.membership_id}</span>
            </div>
            <div className="card-header p-2 text-left border">
              <span><b>会員ランク:</b></span>
              <span className="float-right pr-2"><b>{appState.customer_rank ? appState.customer_rank.rank_name : null}</b></span>
            </div>
            <div className="card-header p-2 text-left border">
              <span><b>店舗:</b></span>
              <span className="float-right pr-2"><b>{appState.shop ? appState.shop.label : null}</b></span>
            </div>
            <div className="card-header p-2 text-left border">
              <span><b>ポイント発生日時:</b></span>
              <span className="float-right pr-2"><b>{appState.point_datetime ? moment(appState.point_datetime).format('YYYY/MM/DD HH:mm') : null}</b></span>
            </div>
            <div className="card-header p-2 text-left border">
              <span><b>ポイント還元{appState.point_rate > 0 ? "率" : "基準額"}:</b></span>
              <span className="float-right pr-2"><b>{appState.point_rate ? Number(appState.point_rate) : appState.point_base_amount ? Number(appState.point_base_amount) : null}</b> {appState.point_rate > 0 ? "％" : "円に1ポイント"}</span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col my-3 text-left bg-white">
            <div className="card-header p-2 border">
              <span><b>決済手段:</b></span>
              <span className='float-right pl-2'>{appState.paymentMethod in constClass.PAYMENT_METHOD_NAME ? constClass.PAYMENT_METHOD_NAME[appState.paymentMethod] : ""}</span>
            </div>
            <div className="card-header p-2 border">
              <span><b>対象金額:</b></span>
              <span className='float-right pl-2'>{appState.inputValue.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })}</span>
            </div>
            <div className="card-header p-2 text-left border">
              <span><b>{appState.pointRegist ? "加算" : "付与予定"}ポイント:</b></span>
              <span className="float-right pr-2"><b>{appState.addPoint.toLocaleString()}</b> ポイント</span>
            </div>
            {/* ポイントキャンペーンが当選する可能性があれば表示 */}
            {appState.pointRegist ? (
              appState.pointCampaignList && appState.pointCampaignList.length > 0 && (
                appState.pointCampaignList.map((item, idx) => (
                  <div className="card-header p-2 text-left border" key={idx}>
                    <span className='pl-5'><b>({item.point_campaign_name}:</b></span>
                    <span className="float-right pr-2"><b>{item.point.toLocaleString()}</b> ポイント)</span>
                  </div>
                ))
              )
            ) : (
              appState.pointCampaignList && (
                appState.pointCampaignList
                  .filter(x => 
                    (!Object.values(constClass.PAYMENT_METHOD).includes(x.payment_method.toString()) || 
                    !appState.paymentMethod || 
                    x.payment_method.toString() === appState.paymentMethod.toString())
                  )
                  .map((item, idx) => (
                    <div key={idx}>
                      {item.m_point_campaign_sub && item.m_point_campaign_sub.map((subItem, subIdx) => {
                        const magnification = subItem.magnification;
                        const calculatedPoints = item.point_limit 
                          ? (appState.addPoint * magnification > item.point_limit 
                            ? (item.point_limit - appState.addPoint).toLocaleString() 
                            : (appState.addPoint * magnification - appState.addPoint).toLocaleString()) 
                          : (appState.addPoint * magnification - appState.addPoint).toLocaleString();

                        if (item.point_limit && appState.addPoint * magnification > item.point_limit) {
                          return null;
                        }

                        return (
                          <div className="card-header p-2 text-left border" key={subIdx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            {subIdx === 0 && (<span className='pl-5' style={{ flex: 1, textAlign: 'left' }}><b>({item.point_campaign_name}</b></span>)}
                            {subIdx > 0 && (<span className='pl-5' style={{ flex: 1, textAlign: 'left' }}><b>(</b></span>)}
                            <span className="float-right pr-2" style={{ flex: 1, textAlign: 'right' }}>
                              {item.m_point_campaign_sub.length > 1 && (<b style={{ marginRight: '10px' }}>{magnification}倍の場合</b>)}
                              <b>{calculatedPoints}</b> ポイント)
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  ))
                )
              )}
          </div>
        </div>
        {appState.pointRegist ?
          <div className="row">
            <div className="col text-center">
              <button
                disabled={lockData}
                className="btn btn-primary w-75"
                onClick={() => setRegistClose()}>
                終了
              </button>
            </div>
          </div>
          :
          <div className="row">
            <div className="col text-center">
              <button
                disabled={lockData}
                className="btn btn-primary w-75 p-3"
                onClick={() => handleSubmitClick()}>
                確定
              </button>
            </div>
            <div className="col text-center">
              <button
                disabled={lockData}
                className="btn btn-enable w-75 p-3"
                onClick={() => handleCloseClick()}>
                戻る
              </button>
            </div>
          </div>
        }
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <UseAlertModal isOpen={isAlertModalOpen} message={alertModalMessage} onClose={closeAlertModal} />
      { !inputFlg && renderInput() }
      { inputFlg && renderConfirm() }
    </div>
  )
}

export default AfterPoint;